<template>
  <div>
    <!-- 重量修改 -->
    <el-dialog :title="$t('message.modificationOfWeigh')" :close-on-click-modal="false"
      :visible.sync="$parent.modificationOfWeighDialogVisible" width="480px" center>
      <div class="content">
        <!-- 重量(kg)： -->
        <div class="label">{{ $t("message.weight") }}(kg) ：</div>
        <div class="val">
          <el-input v-model="weight" onfocus="this.select()" type="number"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.modificationOfWeighDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    ids: { type: Array },
  },
  data() {
    return {
      weight: "",
    };
  },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: this.ids,
        weight: this.weight,
      };
      if (this.weight == "") return this.$message.error("请输入要修改的重量");
      this.$api.inspectionApi.updateBoxWeight(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.modificationOfWeighDialogVisible = false;
        this.$parent.uploadBoxList();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>